// Bump LEGAL_VERSION whenever the Privacy Policy or Terms change. Every DJ is asked to accept the new version (ITER-155).
export const LEGAL_VERSION = '2026-10-14';
export const LEGAL_CONTACT_EMAIL = 'hello@votebeats.com';
export const LEGAL_OPERATOR_NAME = 'DP Solutions LLC';
export const LEGAL_GOVERNING_STATE = 'Wyoming';
export const DJ_MINIMUM_AGE = 16;

export function formatLegalVersion(version: string = LEGAL_VERSION): string {
  const [year, month, day] = version.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
